"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stackConfig = void 0;
var _types = require("./types");
/* istanbul ignore file */

/*
  Contentstack apiKeys and access tokens are for read-only access
  to published (publicly available) content only.
 */
var stackConfig = exports.stackConfig = {
  GlobalComponents: {
    apiKey: 'blt6444b9076ec27f02',
    envs: {
      [_types.Environment.Preview]: {
        name: 'preview',
        token: 'cs32921c345201a090417b8a63'
      },
      [_types.Environment.Qa]: {
        name: 'qa',
        token: 'cs61a1b6b4cd96389fcad2440e'
      },
      [_types.Environment.Production]: {
        name: 'live',
        token: 'cs1a9f7493ebc95bee270e3755'
      }
    }
  },
  Ribbons: {
    apiKey: 'blt83ec2ae5e0dbde7f',
    envs: {
      [_types.Environment.Preview]: {
        name: 'preview',
        token: 'cs64946fe04894aef92af47806'
      },
      [_types.Environment.Qa]: {
        name: 'qa',
        token: 'csaa2f1014874808e3e21fafb3'
      },
      [_types.Environment.Production]: {
        name: 'live',
        token: 'cs6d00ce5ee2d2ea765a12f9fe'
      }
    }
  }
};